// extracted by mini-css-extract-plugin
export default {"skeletonCard":"qnjn3R","imagePlaceholder":"d7keyC","textContainer":"cerddi","textLine":"mqoZMC","textLineShort":"dmrU5U","shimmer":"yNHOsQ"};